<template>
  <v-app id="inspire">
    <v-main>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      >
      <v-layout row>
        <v-flex xs9>
          <v-img
            :src="require('../assets/rect51522.png')"
            width="350"
            class="left"
          />
        </v-flex>
        <v-flex xs3>
          <v-btn
            title="Logout"
            text
            large
            icon
            color="teal"
            class="right mt-2"
            @click="logout()"
          >
            <v-icon title="Logout">
              logout
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-divider />

      <v-alert
        v-model="alert"
        border="left"
        close-text="Close Alert"
        color="blue"
        dark
        dismissible
      >
        Seja bem vindo(a), <b>{{ nomeFormatado(user.nome) }}!</b> <br> Inicialmente, certifique-se do <b>local de atendimento</b>. Logo após, escolha o seu <b>guichê</b>. Então, clique e chame os itens das listas.
      </v-alert>
      <v-layout class="pa-1">
        <v-flex
          xs3
          pa-2
        >
          <v-layout
            align-center
            column
          >
            <v-flex>
              <v-card
                rounded
                hover
                width="205px"
                color="mTeal4"
                dark
                @click="verificaVezChamada"
              >
                <v-card-text class="my-0 pe-0">
                  <h2>Local</h2>
                </v-card-text>
                <v-card-text class=" text-truncate pl-0 my-0 pt-0 ma-1">
                  <div v-if="user.nomeLocal != null">
                    <h1>{{ nomeLocal }}</h1>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- <v-flex  pa-1>
             <div v-if="nomeLocal">
            <v-card width="205px" height="195px"  color="mTeal4" dark>
              <v-card-text class="pa-0">
                <h1>Guichê</h1>
              </v-card-text>
              <v-card-text class="pa-0 text-truncate">
                <p>
                  <font v-if="typeof guiche === 'string' & guiche != '?' " size="4">
                    <h1 class="pa-0 text-truncate pt-3 pb-3">{{guiche}}</h1>
                  </font>
                  <font v-else size="6">
                    <h1 class="pt-2">{{guiche}}</h1>
                  </font>
                </p>
              </v-card-text>
              <v-btn small @click="dialogGuiche = true" color="mTeal2">Alterar</v-btn>
            </v-card>
             </div>
          </v-flex> -->
            <v-flex>
              <div v-if="true">
                <v-menu
                  open-on-hover
                  :close-on-content-click="false"
                  transition="scale-transition"
                  open-delay="150"
                  :nudge-width="50"
                  offset-x
                >
                  <template v-slot:activator="{ on }">
                    <v-card
                      width="205px"
                      color="aBlueDark"
                      dark
                      height="198px"
                      v-on="on"
                    >
                      <v-card-text class="pa-0">
                        <h1>Atendimento</h1>
                      </v-card-text>
                      <v-card-text class="pa-0">
                        <h2>Senha:</h2>
                        <p>
                          <font size="4.7">
                            <h1>{{ mapearLetraPrioridade(atendimento.prioridade) }}{{ atendimento.codigo }}</h1>
                          </font>
                        </p>
                        <h2>Serviço:</h2>

                        <p>
                          <font>
                            <h2 class="text-truncate">
                              {{ atendimento.nomeEspecialidade }}
                            </h2>
                          </font>
                        </p>
                      </v-card-text>
                    </v-card>
                    <v-layout row>
                      <v-flex>
                        <v-btn
                          depressed
                          :disabled="guiche == 0 || !atendimento.codigo.length || iniciouAtendimento || desabilitaBotaoChamar"
                          class="white--text"
                          block
                          color="#BD6D02"
                          @click="fazerChamada()"
                        >
                          chamar <v-icon
                            right
                            dark
                          >
                            record_voice_over
                          </v-icon>
                        </v-btn>
                        <v-btn
                          v-show="!iniciouAtendimento"
                          depressed
                          :disabled="!fezChamada && !isPendente"
                          class="white--text"
                          block
                          color="green"
                          @click="iniciarAtendimento()"
                        >
                          Iniciar Atendimento <v-icon
                            right
                            dark
                          />
                        </v-btn>
                        <v-btn
                          v-show="iniciouAtendimento"
                          depressed
                          class="white--text"
                          block
                          color="green"
                          @click="encerrarAtendimparaento()"
                        >
                          Encerrar <br>Atendimento <v-icon
                            right
                            dark
                          />
                        </v-btn>
                        <v-btn
                          depressed
                          :disabled="!fezChamada && !isPendente || iniciouAtendimento"
                          block
                          color="red"
                          class="white--text"
                          @click="chamadaNaoAtendida()"
                        >
                          não compareceu<v-icon right>
                            close
                          </v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                  <v-card
                    v-if="atendimento.servicos"
                    text
                  >
                    <v-card-text>
                      <h4>Serviços deste Atendimento:</h4>
                      <div
                        v-for="(item, index) in atendimento.servicos"
                        :key="index"
                      >
                        {{ item.nomeServico }}
                        <v-divider
                          v-if="index + 1 < atendimento.servicos.length"
                          :key="index"
                        />
                      </div>
                      <div>
                        <v-divider class="my-2" />
                        Total<strong class="red--text text--darken-2">: {{ this.atendimento.servicos.length }}                                </strong>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-dialog
          v-model="dialogProximasUnidades"
          max-width="530"
        >
          <v-card>
            <v-card-title
              class="white--text headline red pa-2 lighten-2"
            >
              <v-flex row>
                <p class="display-1 text-center">
                  Aviso
                </p>
              </v-flex>
            </v-card-title>
            <v-card-text>
              Verificamos que você mandará o paciente para a unidade
              <strong class="text--lighten-1">{{ mensagemDialogPrimeiraUnidade }}</strong>
              ,e logo após ele retornará para <strong class="text--lighten-1">{{ mensagemDialogSegundaUnidade }}</strong>.
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="green darken-1"
                text="text"
                @click="dialogProximasUnidades = false"
              >
                Voltar
              </v-btn>
              <v-btn
                color="green darken-1"
                text="text"
                @click="adicionarOrdemDeServico(servicosAddOrdemServico)"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogAvisoAtendimento"
          max-width="530"
        >
          <v-card>
            <v-card-title
              class="white--text headline red pa-2 lighten-2"
            >
              <v-flex row>
                <p class="display-1 text-center">
                  Aviso
                </p>
              </v-flex>
            </v-card-title>
            <v-card-text>
              Seu último atendimento durou apenas
              <strong
                class="text--lighten-1"
              >{{ seconds }} segundo(s)</strong>. Por gentileza, inicie o atendimento imediatamente quando o paciente se encontrar próximo ao guichê.
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="green darken-1"
                text="text"
                @click="dialogAvisoAtendimento = false"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- dialogo ordenar exames -->

        <v-layout
          row
          justify-center
        >
          <v-dialog
            v-model="dialogOrdenarExames"
            persistent
            scrollable
            max-width="405px"
          >
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                <v-toolbar-title><h3>Ordenar Exames</h3></v-toolbar-title>
                <v-spacer />

                <v-btn
                  icon
                  @click="novaConsulta()"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text style="height: 300px;">
                <v-list
                  subheader
                  one-line
                >
                  <v-card-title primary-title>
                    <div class="text-truncate">
                      <h3 class="mb-0 text-truncate">
                        {{ nomePaciente }}
                      </h3>
                    </div>
                  </v-card-title>
                  <v-divider />
                  <v-expansion-panels v-if="listaExamesNaoEncontrados.length">
                    <v-expansion-panels-content>
                      <template v-slot:actions>
                        <v-icon color="error">
                          error
                        </v-icon>
                      </template>
                      <template v-slot:header>
                        <div class="red--text">
                          {{ listaExamesNaoEncontrados.length }} exames não encontrados!
                        </div>
                      </template>
                      <v-card>
                        <v-card-text>
                          <div
                            v-for="(item, index) in listaExamesNaoEncontrados"
                            :key="index"
                          >
                            {{ item }}
                            <v-divider
                              v-if="index + 1 < listaExamesNaoEncontrados.length"
                              :key="index"
                            />
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panels-content>
                    <v-divider />
                  </v-expansion-panels>
                  <v-subheader v-if="servicos.length">
                    Exames Pré-ordenados em Sequência
                  </v-subheader>
                  <v-subheader v-else>
                    Nenhum Exame disponível
                  </v-subheader>
                  <draggable v-model="listaServicosAgrupados">
                    <template v-for="(item) in listaServicosAgrupados">
                      <v-list-item
                        :key="item.index"
                        class="pa-1"
                        ripple
                      >
                        <v-list-item-action class="pa-2">
                          <v-icon>
                            drag_indicator
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content hover>
                          <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <v-list-item-title><a v-on="on">{{ item[0].nomeExame }}</a></v-list-item-title>
                              <v-list-item-subtitle v-if="item.unidadePreferencia.filaExame == null">
                                <a
                                  class="black--text"
                                  v-on="on"
                                >Fila {{ item.unidadePreferencia.nomeUnidade }}: 0</a>
                              </v-list-item-subtitle>
                              <v-list-item-subtitle v-else>
                                <a
                                  class="black--text"
                                  v-on="on"
                                >Fila {{ item.unidadePreferencia.nomeUnidade }}: {{ item.unidadePreferencia.filaExame }}</a>
                              </v-list-item-subtitle>
                            </template>
                            <div
                              v-for="(item) in item.fila"
                              :key="item.index"
                            >
                              <span v-if="item[0].filaExame == null"> {{ item[0].nomeUnidade }}: 0</span>
                              <span v-else> {{ item[0].nomeUnidade }}: {{ item[0].filaExame }}</span>
                            </div>
                          </v-tooltip>
                          <v-divider />
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </draggable>
                </v-list>
              </v-card-text>
              <v-card-actions class="pr-4">
                <v-spacer />
                <div v-if="servicos.length">
                  <v-btn
                    rounded
                    color="error"
                    @click="novaConsulta()"
                  >
                    Nova consulta
                  </v-btn>
                  <v-btn
                    rounded
                    color="primary"
                    dark
                    @click="addUnidadesServicos()"
                  >
                    Continuar
                  </v-btn>
                </div>
                <div v-else>
                  <v-btn
                    rounded
                    color="error"
                    @click="novaConsulta()"
                  >
                    Nova consulta
                  </v-btn>
                  <v-btn
                    rounded
                    color="primary"
                    dark
                    @click="encerrarAtendimentoExameNaoEncontrado()"
                  >
                    Sair
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <!-- dialog preferencia -->

        <v-dialog
          v-if="dialogCadastrarPreferencia"
          v-model="dialogCadastrarPreferencia"
          persistent
          scrollable
          max-width="380px"
        >
          <v-card style="width: 470px ">
            <v-toolbar
              color="primary"
              dark
              height="80px"
            >
              <v-toolbar-title>
                <h3 class="blue-grey--text text--darken-4 text-truncate pl-2">
                  Adicionar preferências
                  <br>
                  <v-divider />
                  <div class="white--text text--darken-3 text-truncate pt-2">
                    {{ nomePaciente }}
                  </div>
                </h3>
              </v-toolbar-title>
            </v-toolbar>

            <v-card-text
              v-if="dialogCadastrarPreferencia"
              style="height: 310px;"
            >
              <v-flex xs12>
                <v-text-field
                  v-model="numeroPaciente"
                  v-mask="mask"
                  prepend-inner-icon="phone"
                  hint="Preencha este esse campo corretamente!!"
                  :rules="rules"
                  label="Confirme o número do Paciente:"
                  placeholder="Numero"
                  outlined
                />
              </v-flex>

              <!-- conteudo principal -->
              <v-window v-model="step">
                <v-window-item
                  v-for="(item, index) in listaServicosAgrupados"
                  :key="item.title"
                  :value="index"
                >
                  <v-subheader>{{ item[0].nomeExame }}</v-subheader>

                  <v-layout row>
                    <v-flex xs12>
                      <v-select
                        v-model="item.unidadePreferencia"
                        :items="item.unidades"
                        menu-props="auto"
                        :return-object="true"
                        label="Selecionar Unidade"
                        hide-details
                        item-text="nomeUnidade"
                        single-line
                        @input="setarUnidade(item.unidadePreferencia,index)"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <br>
                      <br>
                    </v-flex>
                  </v-layout>

                  <v-layout row>
                    <v-flex xs12>
                      <v-select
                        v-model="item.medicoPreferencia"
                        :items="item.medicos"
                        menu-props="auto"
                        label="Selecionar Médico"
                        hide-details
                        :return-object="true"
                        no-data-text="Nenhum médico para esta unidade"
                        item-text="nome"
                        single-line
                        @input="setarMedico(index)"
                      >
                        <template
                          slot="item"
                          slot-scope="data"
                        >
                          <template>
                            <v-list-item-avatar>
                              <v-img
                                v-if="data.item.online"
                                class="pa-2"
                                :src="require('../assets/copygreen.png')"
                                width="15px"
                              />
                              <v-img
                                v-else
                                class="pa-2"
                                :src="require('../assets/copy.png')"
                                width="15px"
                              />
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-subtitle
                                class="font-weight-medium"
                                v-html="data.item.nome"
                              />
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-window-item>
              </v-window>
            </v-card-text>
            <v-card-actions class="pr-3">
              <v-btn
                rounded
                icon
                title="Voltar"
                color="deep-orange darken-3"
                @click="()=>{dialogOrdenarExames = true ; voltouOrdenarExames= true; dialogCadastrarPreferencia = false}"
              >
                <v-icon
                  text
                  icon
                  color="white"
                >
                  arrow_back
                </v-icon>
              </v-btn>
              <input
                v-show="false"
                ref="search"
                type="text"
                class="form-control"
                placeholder="Focus On Me"
              >
              <v-spacer />
              <v-btn
                rounded
                :disabled="!verificaNumeroTelefone() || desabilitaBotaoAdicionar"
                color="primary"
                @click="organizarServicosEnviados()"
              >
                Adicionar
              </v-btn>
              <v-icon
                large
                :disabled="step === 0"
                @click="step--"
              >
                arrow_left
              </v-icon>
              <v-icon
                large
                :disabled="step == listaServicosAgrupados.length -1"
                @click="step++"
              >
                arrow_right
              </v-icon>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- inicio dialog servicos -->

        <v-layout
          row
          justify-center
        >
          <v-dialog
            v-model="dialogServicosAtendente"
            persistent
            scrollable
            max-width="350px"
          >
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                <v-toolbar-title>
                  Meus Serviços
                </v-toolbar-title>
                <v-spacer />

                <v-btn
                  icon
                  @click="dialogServicosAtendente = false"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-divider />

              <v-card-text style="height: 270px;">
                <v-list
                  subheader
                  one-line
                >
                  <v-subheader hover>
                    <a @click="selecionarTodosCheckList">{{ textoSelecionarTodos }}</a>
                  </v-subheader>
                  <template v-for="(item, index) in listaServicosRecepcionista">
                      <v-list-item
                      :key="item.title"
                      ripple
                    >
                      <v-list-item-action>
                        <v-checkbox v-model="item.status" />
                      </v-list-item-action>
                      <v-list-item-content @click="item.status = !item.status">
                        <v-list-item-title>{{ item.nomeEspecialidade }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider
                      v-if="index + 1 < listaServicosRecepcionista.length"
                      :key="index"
                    />
                  </template>
                </v-list>
              </v-card-text>
              <v-card-actions class="pr-4">
                <v-spacer />
                <v-btn
                  rounded
                  color="primary"
                  dark
                  @click="adicionarServicosRecepcionista()"
                >
                  Salvar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <!--  dialogo transferir paciente -->

        <v-layout
          row
          justify-center
        >
          <v-dialog
            v-model="dialogTransferirAtendimento"
            persistent
            scrollable
            max-width="350px"
          >
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                <v-toolbar-title>Transferir Atendimento</v-toolbar-title>
                <v-spacer />

                <v-btn icon>
                  <v-icon @click="dialogTransferirAtendimento = false">
                    close
                  </v-icon>
                </v-btn>
              </v-toolbar>
              <v-divider />

              <v-card-text style="height: 270px;">
                <v-subheader v-if="listaTransferirAtendimentosMedicos.length == 0">
                  Não há atendimento para transferir este Paciente
                </v-subheader>
                <v-radio-group v-model="radioGroup">
                  <v-radio
                    v-for="(item, index) in listaTransferirAtendimentosMedicos"
                    :key="index"
                    :label="` ${item.nomeEspecialidade}`"
                    :value="index"
                  />
                </v-radio-group>
              </v-card-text>
              <v-card-actions class="pr-4">
                <v-spacer />
                <v-btn
                  :disabled="listaTransferirAtendimentosMedicos.length == 0"
                  rounded
                  color="primary"
                  @click="transferirAtendimento"
                >
                  Transferir
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <v-dialog
          v-model="dialogCancelarAtendimento"
          persistent
          max-width="370"
        >
          <v-card>
            <v-card-title
              class="white--text headline red lighten-2"
              primary-title
            >
              Cancelar Atendimento
            </v-card-title>

            <v-card-text>
              Ao cancelar este atendimento a ficha será removida do Sistema de filas.
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="black"
                text="text"
                @click="dialogCancelarAtendimento = false"
              >
                Voltar
              </v-btn>
              <v-btn
                color="red darken-1"
                text="text"
                @click="cancelarAtendimento"
              >
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogCancelarEsperaAtendimento"
          max-width="400px"
        >
          <v-card>
            <v-card-title class="teal lighten-1 white--text headline">
              Espera / Cancelar Atendimento
            </v-card-title>
            <v-card-text>
              <v-select
                v-model="elementoListaEsperaCancelar"
                :items="listaEsperaCancelar"
                label="Escolha uma ação"
                item-value="numero"
                item-text="text"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                text
                @click="dialogCancelarEsperaAtendimento=false"
              >
                Voltar
              </v-btn>
              <v-btn
                color="primary"
                text
                @click="verificarItemCancelarEsperaAtendimento"
              >
                ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="aguardandoConexao"

          width="300"
        >
          <v-card
            color="primary"
            dark
          >
            <v-card-text>
              Aguardando conexão...
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              />
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-layout
          row
          justify-center
        >
          <v-dialog
            v-model="dialogMudarLocal"
            scrollable
            max-width="347px"
          >
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                <v-toolbar-title>Modificar Local de Atendimento</v-toolbar-title>
                <v-spacer />
                <v-btn
                  icon
                  @click="dialogMudarLocal = false"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text style="height: 300px;">
                <v-radio-group
                  v-model="idLocalEscolhido"
                  column
                >
                  <div
                    v-for="(item) of listaLocais"
                    :key="item.idLocal"
                  >
                    <v-layout row>
                      <v-flex xs12>
                        <h1 class="title">
                          <v-radio
                            :label="item.nomeLocal"
                            :value="item.idLocal"
                          />
                        </h1>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-radio-group>
              </v-card-text>
              <v-divider />
              <v-card-actions class="pr-4">
                <v-spacer />
                <v-btn
                  :disabled="idLocalEscolhido == null"
                  rounded
                  color="primary"
                  @click="alterarLocal()"
                >
                  Salvar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <v-dialog
          v-model="dialogProximoAtendimento"
          persistent
          max-width="490"
        >
          <v-card>
            <v-card-title
              dark
              class="white--text headline teal lighten-1"
            >
              Por favor, solicite que o paciente dirija-se ao próximo atendimento.
            </v-card-title>
            <v-divider />
            <v-card-text
              v-if="this.mensagemIdProximaUnidade != this.user.idUnidade"
              row
              class="title "
            >
              Unidade: {{ mensagemProximaUnidade }}
            </v-card-text>
            <v-divider />
            <v-card-text pb-0>
              <v-layout
                v-if="consultas.length == 1"
                row
                wrap
              >
                <v-flex class="title text-sm-center pa-2">
                  Serviço:  {{ nomeEspecialidade }}
                </v-flex>
                <v-flex class="title text-sm-center pa-2">
                  Exame:  {{ nomeExame }}
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex class="title text-sm-center">
                  Local:  {{ mensagemProximoLocalDialog }}
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions pa-0>
              <v-spacer />
              <v-btn
                color="green darken-1"
                text
                @click="dialogProximoAtendimento = false"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-layout
          row
          justify-center
        >
          <v-dialog
            id="inspire"
            v-model="dialogGuiche"
            hide-overlay
            max-width="300px"
          >
            <v-card color="#EEEEEE">
              <v-card-text>
                <v-select
                  v-model="guicheSelecionado"
                  :items="guiches"
                  label="Selecione o guichê"
                  item-value="text"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="#212121"
                  text
                  @click="dialogGuiche=false"
                >
                  Voltar
                </v-btn>
                <v-btn
                  rounded
                  color="primary"
                  dark
                  @click="dialogGuiche=false, setarGuiche()"
                >
                  Salvar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <v-layout>
          <v-dialog
            v-model="dialogOs"
            persistent
            max-width="340"
          >
            <v-card>
              <v-card-title
                :class="TextoModalHeadline.class"
                class="white--text headline"
              >
                {{ TextoModalHeadline.texto }}
              </v-card-title>

              <v-card-text>
                <v-flex
                  xs12
                  sm12
                >
                  <v-text-field
                    v-model="codigoOS"
                    type="number"
                    label="Código O.S"
                    hint="adicione o código da O.S para iniciar o atendimento"
                    persistent-hint
                    outlinedd
                    @keyup.enter="retornarServicosOs()"
                  />
                </v-flex>
              </v-card-text>

              <v-card-actions class="pr-3">
                <v-spacer />
                <v-btn
                  rounded
                  color="white--text deep-orange darken-1"
                  @click="dialogTransferirAtendimento = true"
                >
                  Transferir
                </v-btn>
                <v-btn
                  rounded
                  :disabled="!codigoOS.length"
                  color="primary"
                  @click="retornarServicosOs"
                >
                  Consultar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <v-dialog
          v-model="dialogChamadaJaFeita"
          width="500"
        >
          <v-card>
            <v-card-title
              dark
              class=" white--text headline red lighten-2"
              primary-title
            >
              Ficha de atendimento já chamada
            </v-card-title>

            <v-card-text>
              Essa Ficha já foi chamada por um outro Guichê. Escolha uma outra ficha e chame-a imediatamente.<br>
              <strong class="red--text text--lighten-1"> *** Caso esteja chamando um Item da ficha de pendentes, verifique se foi utilizado o mesmo número de guichê ao chamar tal ficha.</strong>
            </v-card-text>

            <v-divider />

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                text
                @click="dialogChamadaJaFeita = false"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogPrimeiroAcesso"
          width="500"
        >
          <v-card>
            <v-card-title
              class="headline red lighten-2 white--text"
              primary-title
            >
              Olá {{ user.nome }}, inicialmente adicione um Local para iniciar o seu atendimento
            </v-card-title>

            <v-card-text>
              <strong class="black--text text--lighten-1"> *** clique no cartão verde, localizado no canto superior esquerdo da tela, para adicionar um local</strong>
            </v-card-text>

            <v-divider />

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                text
                @click="dialogPrimeiroAcesso = false"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogErroMudarLocal"
          width="500"
        >
          <v-card>
            <v-card-title
              class="white--text headline red lighten-2"
              primary-title
            >
              Finalize o atendimento para realizar esta ação.
            </v-card-title>

            <v-card-text>
              <strong class="red--text text--lighten-1">** Finalize o atendimento, ou clique no botão "Não Compareceu", para realizar esta ação.</strong>
            </v-card-text>

            <v-divider />

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                text
                @click="dialogErroMudarLocal = false"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogCronometroAtendimento"
          persistent
          max-width="530"
        >
          <v-card>
            <v-card-title class="blue white--text headline">
              Tempo de atendimento (cadastro da O.S)
            </v-card-title>
            <v-card-text class=" display-4 pt-2 pb-0">
              <div class="cronometro">
                {{ tempoAtendimento }}
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="red darken-1"
                text
                @click="confirmarCancelarEsperaAtendimento"
              >
                Espera / Cancelar Atendimento
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="encerrarCronometroAtendimento"
              >
                Finalizar Atendimento
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-flex
          v-show="exibirTabela"
          xs6
          pa-2
        >
          <v-layout
            wrap
            row
          >
            <v-flex
              xs12
              sm12
              md12
              pr-3
            >
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="desserts"
                  class="elevation-1"
                  items-per-page-text="linhas por página"
                  :items-per-page-options="[10]"
                >
                  <template v-slot:items="props">
                    <td class="title">
                      {{ props.item.nomeEspecialidade }}
                    </td>
                    <td class="title">
                      {{ props.item.count }}
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex
          v-show="!exibirTabela"
          xs3
          pa-2
        >
          <v-layout
            wrap
            row
          >
            <v-flex
              xs12
              sm12
              md12
              pr-3
            >
              <v-card
                v-show="!exibirServicosEspeciais "
                height="500px"
              >
                <v-toolbar
                  text
                  color="aBlueDark"
                  dark
                >
                  <v-toolbar-title class="text-xs-center">
                    Fila sem prioridade
                  </v-toolbar-title>
                  <v-spacer />
                </v-toolbar>
                <v-list
                  v-if="listaSemPrioridade.length > 0"
                  :class="!desabilitaLista() ? 'pulse' : ''"
                  :dense="true"
                  class="scroll-y"
                  style="max-height: 440px"
                  two-line
                >
                  <template v-for="(item, index) in listaSemPrioridade">
                    <div
                      v-if="index == 0"
                      :key="item.title"
                    >
                      <v-list-item
                        :key="item.title"
                        :class="!desabilitaLista() ? 'tile' : ''"
                        :disabled="desabilitaLista()"
                        avatar
                        style="color:#424242"
                        ripple
                        @click="toggle(index)"
                      >
                        <v-list-item-content @click="addAtendimento(item,0)">
                          <v-list-item-title>
                            <p
                              style="color:#424242"
                              class="text-sm-left subheading font-weight-bold"
                            >
                              &nbsp;{{ mapearLetraPrioridade(item.prioridade) }}{{ item.codigo }}
                            </p>
                          </v-list-item-title>
                          <v-list-item-subtitle class="body-1">
                            Horário de chegada: {{ converterDate(item.dataChegada) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    <div
                      v-else
                      :key="item.title"
                    >
                      <v-list-item
                        :key="item.title"
                        disabled
                        avatar
                        ripple
                        @click="toggle(index)"
                      >
                        <v-list-item-content @click="addAtendimento(item,0)">
                          <v-list-item-title disabled>
                            <p
                              style="color:#424242"
                              class="text-sm-left subheading font-weight-bold"
                            >
                              &nbsp;{{ mapearLetraPrioridade(item.prioridade) }}{{ item.codigo }}
                            </p>
                          </v-list-item-title>
                          <v-list-item-subtitle
                            disabled
                            class=" body-1"
                          >
                            Horário de chegada: {{ converterDate(item.dataChegada) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    <v-divider
                      v-if="index + 1 < listaSemPrioridade.length"
                      :key="index"
                    />
                  </template>
                </v-list>
              </v-card>
              <br>

              <v-btn
                hover
                class="white--text rounded-card"
                block
                color="deep-orange darken-3"
                large
                @click="exibirDialogServicosAtendente()"
              >
                <i style="vertical-align: middle">
                  <v-img
                    :src="require('../assets/iconsAdmUnidade/servicos.png')"
                    width="20"
                  />
                </i>&nbsp;&nbsp;&nbsp;&nbsp;SELECIONAR SERVIÇOS
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex
          v-show="!exibirTabela"
          xs3
          pa-2
        >
          <v-layout
            wrap
            row
          >
            <v-flex
              xs12
              sm12
              md12
              pr-3
            >
              <v-card
                v-show="!exibirServicosEspeciais"
                height="500px"
              >
                <v-toolbar
                  text
                  color="aGreen"
                  dark
                >
                  <v-toolbar-title class="text-xs-center">
                    Fila com prioridade
                  </v-toolbar-title>
                  <v-spacer />
                </v-toolbar>
                <v-list
                  :class="desabilitaLista() ? 'pulse' : ''"
                  :dense="true"
                  class="scroll-y"
                  style="max-height: 440px"
                  two-line
                >
                  <template v-for="(item, index) in listaPrioridade">
                    <div
                      v-if="index == 0"
                      :key="item.title"
                    >
                      <v-list-item
                        :key="item.title"
                        :class="desabilitaLista() ? 'tile' : ''"
                        :disabled="!desabilitaLista()"
                        avatar
                        ripple
                        @click="toggle(index)"
                      >
                        <v-list-item-content @click="addAtendimento(item,1)">
                          <v-list-item-title>
                            <p
                              style="color:#424242"
                              class="text-sm-left subheading font-weight-bold"
                            >
                              &nbsp;{{ mapearLetraPrioridade(item.prioridade) }}{{ item.codigo }}
                            </p>
                          </v-list-item-title>
                          <v-list-item-subtitle class=" body-1">
                            Horário de chegada: {{ converterDate(item.dataChegada) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>

                    <div
                      v-else
                      :key="item.title"
                    >
                      <v-list-item
                        :key="item.title"
                        disabled
                        avatar
                        ripple
                        @click="toggle(index)"
                      >
                        <v-list-item-content @click="addAtendimento(item,1)">
                          <v-list-item-title disabled>
                            <p
                              style="color:#424242"
                              class="text-sm-left subheading font-weight-bold"
                            >
                              &nbsp;{{ mapearLetraPrioridade(item.prioridade) }}{{ item.codigo }}
                            </p>
                          </v-list-item-title>
                          <v-list-item-subtitle
                            disabled
                            class=" body-1"
                          >
                            Horário de chegada: {{ converterDate(item.dataChegada) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>

                    <v-divider
                      v-if="index + 1 < listaPrioridade.length"
                      :key="index"
                    />
                  </template>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex
          xs3
          pa-2
        >
          <v-layout
            wrap
            column
          >
            <v-flex
              xs12
              sm12
              md12
              pr-3
            >
              <v-card height="300px">
                <v-toolbar
                  text
                  color="greyPrimaryDark"
                  dark
                >
                  <v-toolbar-title class="text-xs-center">
                    Não compareceu
                  </v-toolbar-title>
                  <v-spacer />
                </v-toolbar>
                <v-list
                  :dense="true"
                  class="scroll-y"
                  style="max-height: 200px"
                  two-line
                >
                  <template v-for="(item, index) in listaNaoCompareceu">
                    <v-list-item
                      :key="item.title"
                      avatar
                      ripple
                      @click="addAtendimento(item,2)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <p
                            style="color:#424242"
                            class="text-sm-left subheading font-weight-bold"
                          >
                            {{ mapearLetraPrioridade(item.prioridade) }}{{ item.codigo }}
                          </p>
                        </v-list-item-title>
                        <v-list-item-subtitle class=" body-1">
                          Horário de chegada:{{ converterDate(item.dataChegada) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider
                      v-if="index + 1 < listaNaoCompareceu.length"
                      :key="index"
                    />
                  </template>
                </v-list>
              </v-card>
              <v-card height="190px">
                <v-toolbar
                  text
                  color="compo3"
                  dark
                >
                  <v-toolbar-title class="text-sm-center">
                    Pendentes
                  </v-toolbar-title>
                  <v-spacer />
                </v-toolbar>
                <v-list
                  :dense="true"
                  class="scroll-y"
                  style="max-height: 120px"
                  two-line
                >
                  <template v-for="(item, index) in listaPendentes">
                    <v-list-item
                      :key="item.title"
                      avatar
                      ripple
                      @click="toggle(index)"
                    >
                      <v-list-item-content @click="addAtendimento(item,3)">
                        <v-list-item-title>
                          <p
                            style="color:#424242"
                            class="text-sm-left subheading font-weight-bold"
                          >
                            {{ mapearLetraPrioridade(item.prioridade) }}{{ item.codigo }}
                          </p>
                        </v-list-item-title>
                        <v-list-item-subtitle class=" body-1">
                          Horário de chegada: {{ converterDate(item.dataChegada) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider
                      v-if="index + 1 < listaPendentes.length"
                      :key="index"
                    />
                  </template>
                </v-list>
              </v-card>
              <v-flex>
                <v-hover>
                  <template v-slot="{ hover }">
                    <v-card
                      :elevation="hover ? 24 : 0"
                      hover
                      dark
                      color="deep-orange darken-3"
                      @click="exibirTabela = !exibirTabela"
                    >
                      <v-card-text
                        v-if="!exibirTabela"
                        hover
                        class=" title pa-3"
                      >
                        <i
                          style="vertical-align: middle"
                          class="material-icons"
                        >
                          <v-img
                            clas
                            :src="require('../assets/android-icon-36x36.png')"
                            width="25"
                          />
                        </i>&nbsp;&nbsp;Quantidade de consultas
                      </v-card-text>

                      <v-card-text
                        v-if="exibirTabela"
                        hover
                        class="title  pl-0 pr-2"
                      >
                        <i
                          style="vertical-align: middle"
                          class="material-icons"
                        >
                          <v-img
                            :src="require('../assets/android-icon-36x36.png')"
                            width="25"
                          />
                        </i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fila de Atendimento
                      </v-card-text>
                    </v-card>
                  </template>
                </v-hover>
              </v-flex>
              <v-flex>
                <v-card
                  class=""
                  dark
                  color="cyan darken-2"
                >
                  <v-card-text class="title px-0">
                    Pacientes não chamados: {{ listaPrioridade.length + listaSemPrioridade.length }}
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex>
                <v-card
                  class=""
                  dark
                  color="cyan darken-2"
                >
                  <v-card-text class="title px-0">
                    Atendimentos realizados: {{ quantAtendimentos }}
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-main>
  </v-app>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import Cookies from "js-cookie";
import _ from 'lodash'
import { mask } from 'vue-the-mask'
import {
  getToken,
  setToken
} from '../store/auth'
import socketService from "../services/socket.service"
import recepcionistaService from "../services/recepcionista.service"
import draggable from 'vuedraggable'


export default {
  name: "homeRecepcionista",
  directives: {
      mask,
	},

	components: {
      draggable,       
	},
	
  data() {
    return {
	  voltouOrdenarExames:false,
    blockCallMethods:false,
    mensagemAutomatico:"",
	  blockMethod:false,
      socket: '',  
	  step: 0,
	  listaEsperaCancelar: [
        { text: 'Cancelar Atendimento', numero:'1' },
        { text: 'Adicionar em Espera', numero:'2' },        
	  ],
	  elementoListaEsperaCancelar:'1',
      unidadePreferencia:'',
      textoSelecionarTodos:"Selecionar todos",
      selecionouTodos:false,
      exibirTabela:false,    
      mask: '###########', 
      exibirServicosEspeciais:false,
	    quantAtendimentos:0,
	    idOrdemServico:'',
      variavelPrioridade: 0,
      variavelPrioridadeEspecial:0,
      DescriçãoLocal:'',
      listaLocais:[],      
      numeroPaciente:'',
      selecionarTodos:false,
      rules: [
        (v) => this.verificaNumeroTelefone() || 'O número deve possuir 11 dígitos ou pode ser vazio'        
      ],
      rules2: [v => v.length <= 11 || 'O número deve ser vazio ou ter 11 digitos'],
	    dialogCancelarAtendimento:false,
	    dialogCancelarEsperaAtendimento:false,
      dialogMudarLocal:false,
      dialogServicos:false,
      isAtendimento: false,
      intervalos:[],
      consultas:[],
      dialogChamadaJaFeita:false,      
      dialogCronometroAtendimento:false,
      nomeEspecialidade: '',
      mensagemProximaUnidade:'',
      mensagemIdProximaUnidade:'',
      mensagemProximoLocal:'',
	  mensagemProximoLocalMontada:'',
	  mensagemProximoLocalDialog:'',
      idExame:'',
      desabilitaBotaoChamar:false,
      idServicoRetornadoDaOs: '',
      idLocalRetornadoDaOs: '',
      tempoAtendimento:'00:00',
      quantVerificarTempoAtendimento:0,
      seconds:0 * 60,
      dialogErroMudarLocal:false,      
      dialogProximoAtendimento: false,
      dialogCadastrarPreferencia: false,
      dialogOs: false,
      dialogPrimeiroAcesso:false,
      dialogServicosAtendente:false,
	  dialogTransferirAtendimento:false,
	  dialogOrdenarExames:false,
    dialogAvisoAtendimento:false,
      dialogProximasUnidades:false,
      radioGroup: 0,
      guiches: [1, 2, 3, 4, 5, 6, 7,'Autorização'],
      alert: true,
      selected: [2],
      TextoModalHeadline: {
        texto: "Código O.S",
        class: "dark-blue lighten-4"
      },
      codigoOS:'',
      fezChamada: false, 
      isPendente:false,     
      aguardandoConexao: false,
      entrouEmAguardandoConexao:false,
      testedialogo: true,
      idMedicoPreferencia: '',
	    idMedico:null,
	    nomeExame:'',
      nomePaciente: '',
      idPaciente:'',
      idServicoTransferir:'',
	    localEscolhido:'',
	    idLocalEscolhido:'',
      idUnidadeServico :'',
	  idLocalMedico:'',
	  servicoMenorFila:'',
      nomeLocal:'',
      medicos: [],      
      servicos: [],      
      iniciouAtendimento: false,
      mensagemNotificacaoSocket: 'default',
      guicheSelecionado: '?',
      segundos: 0 + "0",
      minuto: 0 + "0",
      hora: 0 + "0",
      guiche: 0,
      dialogGuiche: false,
      listaAtendimentos: [],

      tamListaAtendimentos: 0,
      tamListaSemPrioridade: 0,

      listaPrioridade: [],
      listaSemPrioridade: [],
      listaServicosPrioridade:[],
      listaEspecialComPrioridade:[],
      listaEspecialSemPrioridade:[],
      listaPendentes: [],
      listaNaoCompareceu: [],

      listaServicosRecepcionista:[],
      listaTransferirAtendimentosMedicos:[],

      listaTabelaServicos:[],
      itensTabelaConsultas:[], 
      listaQuantConsultas:[],
      
	  listaServicosAgrupados:[],
	  listaExamesNaoEncontrados:[],
      listaMedicosAgrupados:[],
	  desabilitaBotaoAdicionar:true,

    servicosAddOrdemServico:[],
    exibiuDialogProximasUnidades:false,
	  mensagemDialogPrimeiraUnidade:'',
	  mensagemDialogSegundaUnidade: '',
	  mensagemDialogTerceiraUnidade:'',
	  
      atendimento: {
        codigo: "",
        servico: "",
        prioridade: "",
        idAtendimento: "",
        idServico: "",
        dataChegada:"",
        status:"",        
        prioridadeServico:"",
		    nomeEspecialidade:"",
		    dataStatus:"",
		    servicos:[],
       },
        desserts: [
        {
          nomeEspecialidade: '',
          count: 0,
        },
        ],
        headers: [
          {
            text: 'Serviço',
            align: 'center',
            sortable: true,
            value: 'nomeEspecialidade',
          },
          { text: 'Quantidade', value: 'count', sortable: true,align: 'center', },
        
		],	
		
    };
  },
  props: {
    source: String
  },

  computed:{    
     
  },
  
  watch:{
    step: function () {
      if(this.step == this.listaServicosAgrupados.length -1){
         this.desabilitaBotaoAdicionar = false
	  }      
    }
  },
   beforeDestroy: function(){ 
    console.log('em beforeDestroy...');
    this.limparIntervalos()
    this.socket.close()
  },
  created () {
     this.user = this.$store.getters.usuario
     this.nomeLocal = this.user.nomeLocal
     this.retornarLocais()
  },

  methods:{	

  nomeFormatado(str) {
		var arr = str.split(' ');
		if(arr[1] != null){
			var preposicao = arr[1].toLowerCase()			
			if (preposicao == 'de' || preposicao == 'da' || preposicao == 'das' || preposicao == 'do' || preposicao == 'dos') {
				preposicao = true
			 } else{
			   preposicao = false
			  }
	  	}
      return arr.slice(0, preposicao ? 3 : 2).join(' ');
	 },

	mapearLetraPrioridade(prioridade){
     if(prioridade === 0){
        return 'C';
	   }
	   else if(prioridade === 1){
		  return 'P'; 
	   }
	   else if(prioridade === 2){
		 return 'B';  
	   }
	   else if(prioridade === 3){
		 return 'A';  
	   }
	},
    
	proximoLocalPaciente(){
	   // se encontrou nos idLocalMedico do primeiro exame
      if(this.idLocalMedico.indexOf(this.user.idLocal) != -1){
          this.mensagemProximoLocalDialog = this.user.nomeLocal
          this.dialogProximoAtendimento = true   
	     }
	     //se n encontrou nos idLocais do primeiro exame
      else{
        // é com esse qu encontrei que faço a verificação no médico.
        var mensagemProximoLocalAux = []
        var consulta =  this.consultas.find(consulta => 
            consulta.idExame == this.servicoMenorFila.idExame
         );	

        var mensagemAutomatico = consulta.automatico.split(",").map(x=>+x);
        var mensagemProximoLocal = consulta.nomeLocal.split(",");
        mensagemAutomatico.forEach(function (element, index) {
          if(!element){			  
              mensagemProximoLocalAux.push(mensagemProximoLocal[index])
          }
		     }.bind(this));
 
        this.mensagemProximoLocalDialog = mensagemProximoLocalAux.join(' ou '); 
        this.dialogProximoAtendimento = true
	   }	   
	},    

    verificarAtendimento(atendimento){
      var encontrou = false
       this.listaServicosRecepcionista.forEach(servico => {          
          if(servico.status == true){
            atendimento.servicos.forEach(element => {
                if(element.idServico == servico.idServico){
                  encontrou = true
                }
            });
          }
       });
       if(encontrou){
        return true
       }
       else{
         return false
       }
    },

    selecionarTodosCheckList(){
           
       if(this.textoSelecionarTodos == "Selecionar todos"){
          this.listaServicosRecepcionista.forEach(element => {
          element.status = true      
       });
       this.textoSelecionarTodos = "Desmarcar todos"
       return
       }
       if(this.textoSelecionarTodos == "Desmarcar todos"){
          this.listaServicosRecepcionista.forEach(element => {
          element.status = false      
       });
       this.textoSelecionarTodos = "Selecionar todos"
       }
    },

    montarTabelaServico(){
      
      console.log('iterando...tamanho',this.listaTabelaServicos.length);
       for (var index1 = 0; index1 < this.listaTabelaServicos.length; index1++) {              
         this.itensTabelaConsultas[index1]= {nomeEspecialidade:this.listaTabelaServicos[index1].nomeEspecialidade,
         count:0,idServico:this.listaTabelaServicos[index1].idServico}         
         for (var index2 = 0; index2 < this.listaQuantConsultas.length; index2++) {           
           if(this.listaQuantConsultas[index2].idServico == this.listaTabelaServicos[index1].idServico ){  
             this.itensTabelaConsultas[index1].count = this.listaQuantConsultas[index2].count            
           }
         }
       }
    },

    addQuantTabelaConsultas(atendimento){
      console.log('em add quant',atendimento);
      atendimento.servicos.forEach(servicoAtend => {
         this.desserts.forEach( (element, index) => {
           if(servicoAtend.idServico == element.idServico){
              element.count++;              
              this.$set(this.desserts, index, element)
            }
         });
      });
    },
    
    subQuantTabelaConsultas(atendimento){
      console.log('em sub quant',atendimento);
      atendimento.servicos.forEach(servicoAtend => {
         this.desserts.forEach( (element, index) => {
           if(servicoAtend.idServico == element.idServico){              
              if(element.count > 0){
                element.count--;
              }              
              this.$set(this.desserts, index, element)
            }
         });
      });
    },

    transferirAtendimento(){
	  
	  if(!this.blockMethod){

      this.blockMethod = true	  
 
      recepcionistaService.recepcionista
        .transferirAtendimento(this.atendimento.idAtendimento,
        this.listaTransferirAtendimentosMedicos[this.radioGroup].idServico,
        this.atendimento.codigo,this.atendimento.prioridade,
        this.listaTransferirAtendimentosMedicos[this.radioGroup].nomeEspecialidade)
        .then(rsp => { 
          console.log('rsp transferirAtendimento:',rsp);          
          if(rsp.data == true){
			this.dialogTransferirAtendimento = false
			this.exibiuDialogProximasUnidades = false            
			this.fezChamada = false
			this.servicosAddOrdemServico = []
            this.isPendente = false
            this.iniciouAtendimento = false;
            this.atendimento.codigo = "";
            this.atendimento.prioridade = "";
			this.atendimento.nomeEspecialidade = "";  
			this.atendimento.servicos = []          
			this.dialogOs = false
			this.blockMethod = false
          }                  
        })
        .catch(err => {
		  //handle your error here
		  this.blockMethod = false
          console.log(err)
		}) 		
	  }
    },

    exibirDialogServicosAtendente(){
       this.listaServicosRecepcionista = JSON.parse(JSON.stringify(this.user.servicosRecepcionista))
       console.log('---------');
       console.log(this.listaServicosRecepcionista);
       for (let i = 0; i < this.listaServicosRecepcionista.length; i++) {
         const l = this.listaServicosRecepcionista[i];
         if (l.status) {
          this.textoSelecionarTodos = 'Desmarcar todos'
          break
         }
       }
       this.dialogServicosAtendente = true
    },
    
    adicionarServicosRecepcionista(){
      console.log('aquii');      
      this.$store
        .dispatch("ServicosRecepcionista", this.listaServicosRecepcionista)  
        this.retornarAtendimentos()  
        this.dialogServicosAtendente = false    
    },

    confirmarCancelarAtendimento(){
      this.dialogCancelarAtendimento = true;
	},
	
	confirmarCancelarEsperaAtendimento(){
      this.elementoListaEsperaCancelar =  '1'
      this.dialogCancelarEsperaAtendimento = true;
    },
    limparIntervalos() {       
      this.intervalos.forEach(clearInterval);
    },    

    verificaNumeroTelefone(){
       return this.numeroPaciente.length == 0 || this.numeroPaciente.length == 11
	},
	
	verificarItemCancelarEsperaAtendimento(){
	 
    if(this.elementoListaEsperaCancelar == 1){
		this.cancelarAtendimento()		
     }		  
	else if(this.elementoListaEsperaCancelar == 2){
		var atendimento = JSON.parse(JSON.stringify(this.atendimento));
		var index = this.listaPendentes.findIndex(element => element.codigo > atendimento.codigo);
    console.log(index);
    if(index == -1) { this.listaPendentes.push(atendimento)}    
    else { this.listaPendentes.splice(index, 0,atendimento)}  
		
    this.fezChamada = false
    this.isPendente = false
    this.iniciouAtendimento = false;
    this.dialogCronometroAtendimento = false
	this.dialogCancelarAtendimento = false
	this.dialogCancelarEsperaAtendimento = false
	this.atendimento.codigo = ""
	this.elementoListaEsperaCancelar = "1",
	this.atendimento.servicos = []
    this.atendimento.prioridade = "";
    this.atendimento.nomeEspecialidade = ""
    this.limparIntervalos()
    this.seconds = 0 * 60
    this.tempoAtendimento = '00 : 00'
	  }  	  
	},

    cancelarAtendimento(){
      recepcionistaService.recepcionista
        .cancelarAtendimento(this.atendimento.idAtendimento)
        .then(rsp => { 
          console.log('rsp cancelarAtendimento',rsp);          
          if(rsp.status == 200){  
            
            this.fezChamada = false
            this.isPendente = false
            this.iniciouAtendimento = false;
            this.dialogCronometroAtendimento = false
			this.dialogCancelarAtendimento = false
            this.dialogCancelarEsperaAtendimento = false
            this.atendimento.codigo = ""
            this.elementoListaEsperaCancelar = "1",
            this.atendimento.servicos = []
            this.atendimento.prioridade = "";
            this.atendimento.nomeEspecialidade = ""
            this.limparIntervalos()
            this.seconds = 0 * 60
            this.tempoAtendimento = '00 : 00'
          }                  
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })   
    },

    encerrarCronometroAtendimento(){
      this.dialogCronometroAtendimento = false      
      this.limparIntervalos()
      this.abrirDialogoOS()
    },

    verificaVezChamada(){
       if(this.fezChamada){
          this.dialogErroMudarLocal = true;
          return
       }
       this.dialogMudarLocal = true
    },


    refreshToken() {  
      console.log('token antes:',getToken());

      recepcionistaService.recepcionista
        .refreshToken(getToken())
        .then(rsp => { 
          console.log('rsp refreshToken',rsp);          
          if(rsp.status == 200){
            setToken(rsp.data.token)
            console.log('token dps',getToken());
            
            this.socket.close()
            this.socket = io.connect(socketService.SOCKET_URL, {
              query: {
                token: getToken()
              }
            });
            this.chamarSocket();  
            this.retornarMedicos()
		    //this.retornarServicos()			
          }                  
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })      
    },

    alterarLocal(){  

      recepcionistaService
        .recepcionista.alterarLocal(Number(this.idLocalEscolhido))
        .then(rsp => {
          console.log(rsp);          
          if(rsp.data == true){
			//var medicos = this.servicos.filter(element => element.idUnidade2 == unidadePreferencia.idUnidade ); 
			var local = this.listaLocais.filter(element => element.idLocal == this.idLocalEscolhido)
            this.$store
           .dispatch("Local", local[0].nomeLocal)
			this.nomeLocal = local[0].nomeLocal;
			this.user.idLocal = local[0].idLocal			
			this.fezChamada = false
			this.isPendente = false
			this.user.guiche = undefined
			this.guiche = '?'
			this.guiche = !this.user.guiche ? '?' : this.user.guiche
			this.atendimento.codigo = ""
			this.atendimento.prioridade = ""
		    this.atendimento.servicos = []
			this.atendimento.nomeEspecialidade = ""	

			this.$store
        .dispatch("UpdateUser", this.user)
			this.dialogMudarLocal = false
			this.user.servicosRecepcionista = false
			this.itensTabelaConsultas = []
      this.retornarServicos() 
      //this.retornarPrioridade()
	    this.refreshToken()
      } 
      else{
        alert("ocorreu um erro durante a requisição")
      }                   
      })
      .catch(err => {
         //handle your error here
         console.log(err);
      })
    },
    
    desabilitaLista() { //se igual a zero retorna true
      if (this.listaPrioridade.length > 0 && this.listaSemPrioridade.length > 0 ){
        //return this.variavelPrioridade == 0; // returna verdadeiro se 0
        if(this.listaPrioridade[0].dataChegada < this.listaSemPrioridade[0].dataChegada ){
          return true;
		}
		if(this.variavelPrioridade == 0){
		 	return true
		}
	  }
      else if (this.listaSemPrioridade.length == 0 && this.variavelPrioridade == 0){// e verificar o primeiro da lista 
        return true;
      }
      else if (this.listaSemPrioridade.length == 0 && !this.variavelPrioridade == 0){
        return true;
      }

	 },
	 
	 retornarLocais(){
       recepcionistaService
        .recepcionista.retornarLocais()
        .then(rsp => {
          console.log('rsp retornarLocais:',rsp);
          this.listaLocais = rsp.data;
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        })
	},    
    

	toggle() { },
	
	exibirDialogProximasUnidades(){
	var idUnidadeRecepcionista = this.user.idUnidade
	var retorno = true
    if(this.servicosAddOrdemServico.length > 1 && !this.exibiuDialogProximasUnidades){
      for (let index = 1; index < this.servicosAddOrdemServico.length; index++) {
        const element1 = this.servicosAddOrdemServico[index-1];
		    const element2 = this.servicosAddOrdemServico[index];        
		    const element3 = this.servicosAddOrdemServico[index+1]; 
		if(element2.idUnidade == idUnidadeRecepcionista && element1.idUnidade != idUnidadeRecepcionista){
           this.mensagemDialogPrimeiraUnidade = element1.nomeUnidade
		   this.mensagemDialogSegundaUnidade = element2.nomeUnidade
		   this.dialogProximasUnidades = true  
           this.exibiuDialogProximasUnidades = true
		   retorno = false  
		   break
		}
      }
    }
     return retorno
	},
	
	organizarServicosEnviados(){

	  if(!this.blockMethod){
      this.blockMethod = true	  

     console.log('em organizar...');  
	 this.servicosAddOrdemServico = []	 
     this.listaServicosAgrupados.forEach(element => {
	   var servico = {
		 idServico: element.unidadePreferencia.idServico,
		 idExame:element[0].idExame,
		 filaExame: element.unidadePreferencia.filaExame,
		 idMedico:element.medicoPreferencia.idMedico,
		 peso:element.unidadePreferencia.peso,
		 idLocaisMedico:element.idLocaisMedico,
		 idUnidade:element.unidadePreferencia.idUnidade,
		 nomeUnidade:element.unidadePreferencia.nomeUnidade,
     idPrestadorAuxiliar: element.idPrestadorAuxiliar
     }
     
     this.servicosAddOrdemServico.push(servico)
	 });	 
	 console.log('em organizarServicosEnviados',this.servicosAddOrdemServico); 
	 	 
	 this.servicosAddOrdemServico[0].status = 1
	 this.servicoMenorFila = this.servicosAddOrdemServico[0]
  
	for (let index = 1; index < this.servicosAddOrdemServico.length; index++) {
		const element = this.servicosAddOrdemServico[index];		
		if(element.peso >= this.servicosAddOrdemServico[0].peso && element.idUnidade == this.servicosAddOrdemServico[0].idUnidade ){
		   element.status = 1
		   if(element.filaExame < this.servicoMenorFila.filaExame){
              this.servicoMenorFila = element
		   }
		}
		else{
		   element.status = 0
		}
	}
	
	if(this.exibirDialogProximasUnidades()){
      this.adicionarOrdemDeServico(this.servicosAddOrdemServico)
	} 
   }
  },

  agruparConjuntoIdLocaisMedico(){
      var result = []
      this.servicosAddOrdemServico.forEach(element => {
        if(element.status == 1){
          result = Array.from(new Set([...result,...element.idLocaisMedico]))         
        } 
      });
      this.servicosAddOrdemServico.forEach(element => {
        if(element.status == 1){
           element.idLocaisMedico = result
        } 
      });
  },

    adicionarOrdemDeServico(servicosAddOrdemServico) { // segunda vez
    console.log('addOrdemServico-ServAgrupados',this.listaServicosAgrupados);	  
	    
      this.agruparConjuntoIdLocaisMedico()
      console.log('servi add Ordem Servico agrupados',servicosAddOrdemServico);        

      recepcionistaService
        .recepcionista.adicionarOrdemDeServico(this.codigoOS, this.atendimento.idAtendimento,servicosAddOrdemServico)
        .then(rsp => {
          console.log('rsp adicionarOrdemDeServico:',rsp);  
          if(rsp.status == 200){
          this.step = 0
		      this.exibiuDialogProximasUnidades = false
		      this.dialogProximasUnidades = false          
          this.isPendente = false
          this.desabilitaBotaoAdicionar = true
		      this.consultas = JSON.parse(JSON.stringify(rsp.data))			  	  
          this.mensagemProximaUnidade = rsp.data[0].nomeUnidade
          this.mensagemIdProximaUnidade = rsp.data[0].idUnidadeServico
          this.mensagemProximoLocal = rsp.data[0].nomeLocal.split(',');          
          this.idLocalMedico = rsp.data[0].idLocalMedico.split(',').map(x=>+x);
		      this.idExame = rsp.data[0].idExame
          this.idMedico = rsp.data[0].idMedico     
		      this.nomeExame = rsp.data[0].nomeExame
          this.idUnidadeServico = rsp.data[0].idUnidadeServico          
          this.nomeEspecialidade = rsp.data[0].nomeEspecialidade
          this.idServicoRetornadoDaOs = rsp.data[0].idServico
		      this.idLocalRetornadoDaOs = rsp.data[0].idLocal
		      this.idOrdemServico = rsp.data[0].idOrdemServico          
          this.dialogCadastrarPreferencia = false
          this.iniciouAtendimento = true
          this.TextoModalHeadline.texto = "Código O.S"
          this.TextoModalHeadline.class = "blue lighten-3"
		      this.codigoOS = ''
		      this.dialogOrdenarExames = false
		      this.dialogOs = false
		      this.voltouOrdenarExames = false
          this.proximoLocalPaciente()
		      this.encerrarAtendimento()    
		      this.blockMethod = false      
          }
          
        })
        .catch(err => {
		  // handle your error here
		  this.blockMethod = false
          console.log(err);
        })
    },    

    setarPreferencia(index) {
      console.log('em setar preferencia',index);
      this.servicos[index].idMedico = this.idMedicoPreferencia;
      this.idMedicoPreferencia = ''
    },

    

    setarUnidade(unidadePreferencia,index) {
      
	  console.log('escooo',unidadePreferencia);  
	  var medicoDefault = { nome: 'Sem Médico de Preferência' ,idMedico:''}
      var medicos = this.servicos.filter(element => element.idUnidade2 == unidadePreferencia.idUnidade
      && element.idExame == this.listaServicosAgrupados[index][0].idExame);      
      
      this.listaServicosAgrupados[index].medicoPreferencia = ''   
	  this.listaServicosAgrupados[index].medicos = medicos; 
	  this.listaServicosAgrupados[index].idLocaisMedico = []
	  this.listaServicosAgrupados[index].medicos.forEach(element => {
			this.listaServicosAgrupados[index].idLocaisMedico.indexOf(element.idLocalMedico) === -1 ? 
			this.listaServicosAgrupados[index].idLocaisMedico.push(element.idLocalMedico) : '';
		});
	  this.listaServicosAgrupados[index].medicos.push(medicoDefault);
      console.log('agrupa apos',this.listaServicosAgrupados );   
            
	},
	
    setarMedico(index) {
      console.log('setar Unidade',index);  
      console.log('agrupa apos',this.listaServicosAgrupados );       
    },

    organizarDadosInterfacePreferencia(){
	  
	  this.listaServicosAgrupados = this.groupBy(this.servicos, "idExame")
	  console.log('dados agrupados',this.listaServicosAgrupados);
      this.listaServicosAgrupados.forEach(element => {
      this.$set(element, 'fila', [])
	  this.$set(element, 'unidadePreferencia','') // adicionei
	  
	  var unidadePreferencia = { nomeUnidade: element[0].nomeUnidade ,idUnidade:element[0].idUnidade2,
	  filaExame:element[0].filaExame,peso:element[0].peso,idServico:element[0].idServico2}

      element.unidadePreferencia = unidadePreferencia
		  element.fila = this.groupBy(element, "idUnidade2")
	  });
	  console.log('apos iteracao',this.listaServicosAgrupados);
      if(this.listaServicosAgrupados.length == 1){
        this.desabilitaBotaoAdicionar = false
	  }  
	  this.dialogOrdenarExames = true    
      //this.addUnidadesServicos() 
  },

  chamarModalConexao() {
      console.log('em chamarModalConexao..');

      if (this.mensagemNotificacaoSocket == 'aguardando conexao') {
        console.log('em if aguard conex')
        this.aguardandoConexao = true
        this.entrouEmAguardandoConexao = true
      }
      if (this.mensagemNotificacaoSocket == 'conectado') {
        this.aguardandoConexao = false
        if (this.entrouEmAguardandoConexao) {
          this.retornarAtendimentos()
          this.entrouEmAguardandoConexao = false
        }
      } else if (this.mensagemNotificacaoSocket == 'desconectado') {
        this.aguardandoConexao = true
      }
    },
  
     
    addUnidadesServicos(){
		this.dialogOrdenarExames = false
				
        if(this.voltouOrdenarExames){
		  this.dialogCadastrarPreferencia = true
          return
		}
        this.listaServicosAgrupados.forEach((servicoGrupo,index) => {            
        this.$set(servicoGrupo, 'unidades', [])   
		this.$set(servicoGrupo, 'medicos', [])  
		this.$set(servicoGrupo, 'idLocaisMedico', [])
        this.$set(servicoGrupo, 'unidadePreferencia','')
        this.$set(servicoGrupo, 'medicoPreferencia','')  

		var unidadePreferencia = { nomeUnidade: servicoGrupo[0].nomeUnidade ,idUnidade:servicoGrupo[0].idUnidade2,
		filaExame:servicoGrupo[0].filaExame,peso:servicoGrupo[0].peso,idServico:servicoGrupo[0].idServico2}
        servicoGrupo.unidadePreferencia = unidadePreferencia

        var medicos = this.servicos.filter(element => element.idUnidade2 == unidadePreferencia.idUnidade
          && element.idExame == servicoGrupo[0].idExame
        ); 

		servicoGrupo.medicos = medicos
		servicoGrupo.medicos.forEach(element => {
			servicoGrupo.idLocaisMedico.indexOf(element.idLocalMedico) === -1 ? servicoGrupo.idLocaisMedico.push(element.idLocalMedico) : '';
		});

        var medicoDefault = { nome: 'Sem Médico de Preferência' ,idMedico:''}
        servicoGrupo.medicos.push(medicoDefault)
          // aqui add a preferencia...
            this.servicos.forEach(element => { // iteracao para saber as unidades de cada exame agrupado
               
                if(servicoGrupo[0].idExame == element.idExame){

				  var unidade = { nomeUnidade: element.nomeUnidade, idUnidade:element.idUnidade2,
				  filaExame:element.filaExame,peso:element.peso,idServico:element.idServico2}

                if( this.listaServicosAgrupados[index].unidades.findIndex(
                    element => element.idUnidade2 == unidade.idUnidade) == -1 )
                    {
                    this.listaServicosAgrupados[index].unidades.push(unidade)
                    }                  
                }
                });
        });  
        console.log('listaServicosAgrupados apos addUnidade',this.listaServicosAgrupados);  
        this.dialogCadastrarPreferencia = true
    },

    addMedicosExame(){
      this.listaServicosAgrupados.forEach((servicoGrupo,index) =>  {  
            this.listaServicosAgrupados[index].medicos = [] 
            this.servicos.forEach(element => {
              
               if(servicoGrupo[0].idExame == element.idExame){
                 var medico = { nomeUnidade: servicoGrupo.nomeUnidade ,idUnidade:servicoGrupo.idUnidade2} 
                 if( this.listaServicosAgrupados[index].unidades.findIndex(
                  element => element.idUnidade == unidade.idUnidade) == -1 )
                  {
                   this.listaServicosAgrupados[index].medico.push(unidade)
                  }
               }
            });
        });
    },

    novaConsulta() {
    this.step = 0
    this.exibiuDialogProximasUnidades = false
	  this.servicosAddOrdemServico = []
	  this.dialogOrdenarExames = false
	  this.desabilitaBotaoAdicionar = true
      this.TextoModalHeadline.texto = "Código O.S"
      this.TextoModalHeadline.class = "blue"
      this.dialogCadastrarPreferencia = false
      this.dialogOs = true;
      this.codigoOS = ""
	  this.nomePaciente = ""
	  this.voltouOrdenarExames = false
    },

    // recepcionista chama retornar medicos
    retornarMedicos() {
      
      recepcionistaService
        .recepcionista.retornarMedicos()
        .then(rsp => {
          console.log('rsp retornarMedicos:',rsp);
          console.log();
          this.retornarPrioridade()
          this.medicos = rsp.data;
          this.medicos.forEach(medico => {
             if(medico.online == 1){
               medico.icone = 'done'
             }
             else{
               medico.icone = 'clear'
             }
          });
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        })
    },

    abrirDialogoOS() {
      this.dialogOs = true;
    },

    retornarServicosOs() {

      if (!this.codigoOS.length){
        console.log('return os length..');          
        return
      }
      else{
        this.TextoModalHeadline.texto = "Código O.S"
        this.TextoModalHeadline.class = "blue"
	  }
	  
	  if(!this.blockMethod){

      this.blockMethod = true	  

      console.log(' em retornar exames os');
      recepcionistaService.recepcionista
        .retornarExamesOs(this.codigoOS) //antiga rota : retornarServicosUsuarioOs
        .then(rsp => {
		  console.log('rsp de chamar codigo os:',rsp)
          if(rsp.status == 200){
          if(rsp.data == 1){
				  this.TextoModalHeadline.texto = "Código não encontrado. Tente novamente"
           this.TextoModalHeadline.class = "red lighten-2"
				}
          else if(rsp.data == 2){
          this.TextoModalHeadline.texto = "O.S cadastrada em outra unidade !"
          this.TextoModalHeadline.class = "red lighten-2"
          }
          else if(rsp.data == 3){
          this.TextoModalHeadline.texto = "O.S cadastrada em outra data !"
          this.TextoModalHeadline.class = "red lighten-2"
          }
          else{
            this.servicos = rsp.data.servicos;
            this.exibiuDialogProximasUnidades = false
            this.numeroPaciente = rsp.data.celular == null ? '00000000000': rsp.data.celular;
            this.nomePaciente = rsp.data.nome;
            this.listaExamesNaoEncontrados = rsp.data.examesNaoEncontrados
            this.idPaciente = rsp.data.id 
            this.dialogoOS = false 
            this.dialogOs = false          
            this.organizarDadosInterfacePreferencia()	
		  }
		  this.blockMethod = false
		  } 
		  else{
			this.blockMethod = false
		    this.TextoModalHeadline.texto = "Ocorreu um erro. Tente novamente"
        this.TextoModalHeadline.class = "red lighten-2"
		  }
        })
        .catch(err => {
		  console.log('error.......');
		  this.blockMethod = false
          this.TextoModalHeadline.texto = "Ocorreu um erro. Tente novamente"
          this.TextoModalHeadline.class = "red lighten-2"
          console.log(err);
		})
	  }
    },

    retornarPrioridade(){
        
      recepcionistaService
        .recepcionista.retornarPrioridade()
        .then(rsp => {
          console.log('rsp retornarPrioridade',rsp.data);          
          this.variavelPrioridade = rsp.data.prioridade
          this.variavelPrioridadeEspecial = rsp.data.prioridadeEspecial
        })
        .catch(err => {
          //handle your error here
          console.log(err);
        })
    },

    retornarAtendimentos() {
      
      recepcionistaService
        .recepcionista
        .retornarAtendimentos()
        .then(rsp => {
          console.log('rsp retornarAtendimentos:', rsp.data);
          this.listaAtendimentos = rsp.data;
          this.listaPrioridade = [];
          this.listaSemPrioridade = [];
          this.listaPendentes = [];
          this.listaNaoCompareceu = []
          console.log('lista geral..');
          console.log(this.listaAtendimentos);
          
          this.listaAtendimentos.forEach(atendimento => {
              if(atendimento.prioridade == 0 && atendimento.status == 1 ||  atendimento.prioridade == 2 && atendimento.status == 1){                
                if(this.verificarAtendimento(atendimento)){
                  this.listaSemPrioridade.push(atendimento)
                }
              }
              if(atendimento.prioridade == 1 && atendimento.status == 1 ||  atendimento.prioridade == 3 && atendimento.status == 1){                
                if(this.verificarAtendimento(atendimento)){
                  this.listaPrioridade.push(atendimento)
                }
              }              
              if(atendimento.status == 2){
                  this.listaPendentes.push(atendimento)
              }
              if(atendimento.status == 3){
                  this.listaNaoCompareceu.push(atendimento)
              } 
          });
                   
        })
        .catch(err => {
          // handle your error here
          console.log('erro catch');
          console.log(err);
        })
    },

    
    chamarSocket() {      

      this.socket.on('medicoOffline', function (mensagem) {
        console.log('skt medicoOffline',mensagem);

        this.medicos.forEach(medico => {
          if(medico.idMedico == mensagem){
             medico.online = 0
             medico.icone = 'clear'
          }
        });
        //this.medicos = medicosAux
      }.bind(this));

       this.socket.on('chamadaNaoAtendida', function (atendimento) {
        console.log('skt chamada n atendida..');
        console.log(atendimento);
        atendimento.status = 3;
        this.listaNaoCompareceu.push(atendimento)        
       }.bind(this));

      this.socket.on('novoAtendimento', function (atendimento) {
        console.log('skt novoAtendimento',atendimento);

        if(atendimento.atendimentoTransferido){
          console.log('tranferido..');  
          if(this.verificarAtendimento(atendimento)){
             if(atendimento.prioridade == 0 ||  atendimento.prioridade == 2){
              var index = this.listaSemPrioridade.findIndex(element => element.codigo > atendimento.codigo);
              console.log(index);
              if(index == -1) { this.listaSemPrioridade.push(atendimento)}    
               else { this.listaSemPrioridade.splice(index, 0,atendimento)}  
              }

             if(atendimento.prioridade == 1 ||  atendimento.prioridade == 3){ 
              var index = this.listaPrioridade.findIndex(element => element.codigo > atendimento.codigo);
              console.log(index);              
              if(index == -1) { this.listaPrioridade.push(atendimento)}   
              else {this.listaPrioridade.splice(index, 0,atendimento)}   
              
             } 
          }        
        }    
            
        else{
          if(this.verificarAtendimento(atendimento)){
            if(atendimento.prioridade == 0 ||  atendimento.prioridade == 2){
                this.listaSemPrioridade.push(atendimento)
            }
            if(atendimento.prioridade == 1 ||  atendimento.prioridade == 3){ 
                this.listaPrioridade.push(atendimento)
           }  
          }
        }        
        this.addQuantTabelaConsultas(atendimento)
       }.bind(this));

        this.socket.on('chamando', function (mensagem) {
	      console.log('skt chamando..',mensagem);
		        
        this.listaSemPrioridade.forEach(function (element, index)  {
          if(element.codigo == mensagem.codigo){
		      	this.subQuantTabelaConsultas(element)
			      this.listaSemPrioridade.splice(index, 1);			
            this.alterarVariavelPrioridade()
            return
          }
        }.bind(this));

        this.listaPrioridade.forEach(function (element, index) {
          if(element.codigo == mensagem.codigo){
			      this.subQuantTabelaConsultas(element)
            this.listaPrioridade.splice(index, 1);
            this.alterarVariavelPrioridade()
            return
          }
        }.bind(this));  

        this.listaNaoCompareceu.forEach(function (element, index) {
          if(element.codigo == mensagem.codigo){
            this.listaNaoCompareceu.splice(index, 1);            
            return
          }
        }.bind(this));         
      }.bind(this));

      this.socket.on('connect', function (mensagem) {
        this.mensagemNotificacaoSocket = "conectado";
        this.chamarModalConexao();
      }.bind(this));

      this.socket.on('connect_error', () => {
        this.mensagemNotificacaoSocket = "aguardando conexao"
        this.chamarModalConexao();
      });

      this.socket.on('disconnect', function () {
        this.mensagemNotificacaoSocket = "desconectado";
        this.chamarModalConexao();
      }.bind(this))

    },

    alterarVariavelPrioridade() {
       //if (!this.fezChamada) {
        console.log('altera prioridade');        
        if (this.variavelPrioridade == 0) {          
          this.variavelPrioridade = 3;          
        } else {          
          this.variavelPrioridade = this.variavelPrioridade - 1;          
        }
     // }
    },
    alterarVariavelPrioridadeEspecial() {
      //if (!this.fezChamada){
        console.log('altera prioridade especial');        
        if (this.variavelPrioridadeEspecial == 0) {          
          this.variavelPrioridadeEspecial = 3;          
        } else {          
          this.variavelPrioridadeEspecial = this.variavelPrioridadeEspecial - 1;          
        }
     // }
    },

    converterDate(data) {
      var d = new Date(data);
      var minutes = d.getMinutes().toString();
      minutes = minutes.length == 1 ? "0" + minutes : minutes;
      var hours = d.getHours().toString();
      hours = hours.length == 1 ? "0" + hours : hours;

      return hours + ":" + minutes;
    },

    addAtendimento(item,idList) {
	  console.log(item);
	  
	if(this.fezChamada){
        this.dialogErroMudarLocal = true;
      return
	  } 
      if(idList == 3){
        this.isPendente = true        
	  }
	  else{
       this.isPendente = false       
	}     
    this.fezChamada = false
    this.iniciouAtendimento = false
    this.atendimento.codigo = item.codigo;
    this.atendimento.idServico = item.idServico;
    this.atendimento.nomeEspecialidade = item.nomeEspecialidade;
    this.atendimento.prioridade = item.prioridade;
    this.atendimento.idAtendimento = item.idAtendimento;      
    this.atendimento.dataChegada = item.dataChegada
	this.atendimento.prioridadeServico = item.prioridadeServico
	this.atendimento.dataStatus = item.dataStatus
    this.atendimento.servicos = item.servicos
    console.log('atendimento',this.atendimento);   
    },

    fazerChamada() {

      this.desabilitaBotaoChamar = true
      //Re-enable after 6 seconds
      this.timeout = setTimeout(() => {      
          this.desabilitaBotaoChamar = false
      }, 10 * 1000)
      
      recepcionistaService
        .recepcionista
        .fazerChamada(this.atendimento.idAtendimento,
          this.atendimento.codigo, this.guiche, this.atendimento.prioridade)
        .then(rsp => {
          console.log('rsp fazerChamada',rsp);          
          
          if (rsp.data == true) {          
          this.fezChamada = true;
          this.listaPendentes.forEach((element, index) => {
            if (element.codigo == this.atendimento.codigo) {			       
              this.listaPendentes.splice(index, 1);
            }
          });
          }
          if (rsp.data == false) {                        
            this.dialogChamadaJaFeita = true
          }

        })
        .catch(err => {
          // handle your error here
          console.log(err);
        })
    },

    chamadaNaoAtendida() {
      
      recepcionistaService
        .recepcionista
        .chamadaNaoAtendida(this.atendimento.idAtendimento,this.atendimento.codigo,
        this.atendimento.nomeEspecialidade,this.atendimento.idServico,this.atendimento.prioridade,
        this.atendimento.dataChegada,this.atendimento.servicos)
        .then(rsp => {          
          console.log('rsp chamadaNaoAtendida:',rsp);
          if (rsp.data == true) {
            this.listaPendentes.forEach((element, index) => {
            if (element.codigo == this.atendimento.codigo) {
			        //this.subQuantTabelaConsultas(this.atendimento) // add agora
              this.listaPendentes.splice(index, 1);
             }
            });
            this.isPendente = false
            this.fezChamada = false
            this.iniciouAtendimento = false;
            this.atendimento.codigo = "";
            this.atendimento.prioridade = "";
			      this.atendimento.nomeEspecialidade = "";
			      this.atendimento.servicos = []
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        })
    },

    timeDurationToString(duration) {
      return duration > 9 ?
        duration :
        '0' + duration
    },

    iniciarCronometroAtendimento() {                      
      this.seconds += 1
      const minutesLeft = Math.floor(this.seconds / 60)
      const secondsLeft = this.seconds % 60
      this.tempoAtendimento = this.timeDurationToString(minutesLeft) + ' : ' + this.timeDurationToString(secondsLeft)
    },

    iniciarAtendimento() {
      if(!this.blockMethod){

      this.blockMethod = true	  
	 	
      this.seconds = 0 * 60
      this.tempoAtendimento = '00 : 00'
      this.TextoModalHeadline.texto = "Código O.S"
      this.TextoModalHeadline.class = "blue"
      this.codigoOS = ""

      recepcionistaService
        .recepcionista
        .iniciarAtendimento(this.atendimento.codigo,
          this.atendimento.idAtendimento)
        .then(rsp => {
          console.log('rsp iniciarAtendimento:',rsp)          
          if (rsp.data == true) {
            this.listaPendentes.forEach((element, index) => {
            if (element.codigo == this.atendimento.codigo) {			        
              this.listaPendentes.splice(index, 1);
             }
            });                       
            this.dialogCronometroAtendimento = true
            var i1 = setInterval(() => this.iniciarCronometroAtendimento(), 1000);
			this.intervalos.push(i1);
			this.blockMethod = false
          }
        })
        .catch(err => {
          // handle your error here
		  console.log('erro. caiu no cath');
		  this.blockMethod = false
          console.log(err);
		})
	  }
    },

    examesNaoEncontrados(){
	var quantAux = this.user.quantAtendimentos + 1
    this.$store
    .dispatch("QuantAtendimentos",quantAux )
    this.quantAtendimentos = quantAux
	this.dialogOs = false
	this.dialogOrdenarExames = false
    this.fezChamada = false
	this.atendimento.codigo = ""
	this.atendimento.servicos = []
    this.atendimento.nomeEspecialidade = ""
    this.atendimento.prioridade = ""
    
	  },

    encerrarAtendimentoExameNaoEncontrado(){
        recepcionistaService
        .recepcionista
        .encerrarAtendimentoExameNaoEncontrado(this.atendimento.idAtendimento,
          this.codigoOS,this.nomePaciente,this.numeroPaciente,this.idPaciente)
        .then(rsp => {
          console.log('rsp encerrarAtendimentoExamesNaoEncontrado:',rsp)          
          if (rsp.data == true) {            
            console.log('entrou no true',);   
            var quantAux = this.user.quantAtendimentos + 1
            this.$store
            .dispatch("QuantAtendimentos",quantAux )
            this.quantAtendimentos = quantAux
            this.dialogOs = false
            this.dialogOrdenarExames = false
			this.fezChamada = false
			this.isPendente = false
            this.atendimento.codigo = ""
            this.atendimento.servicos = []
            this.atendimento.nomeEspecialidade = ""
			this.atendimento.prioridade = ""     
			this.verificarTempoAtendimento(false)    
            
          }
        })
        .catch(err => {
          // handle your error here          
          console.log(err);
        })
    },

    encerrarAtendimento() { // quem pega é o medico
      console.log('em encerrar atendimento...');
      this.iniciouAtendimento = false;
      
      recepcionistaService
        .recepcionista
        .encerrarAtendimento(this.atendimento.idAtendimento,
         this.atendimento.codigo,
         this.atendimento.prioridade,this.nomePaciente,this.numeroPaciente,
         this.idPaciente,this.idMedico,
         this.consultas)
        .then(rsp => {
          console.log('rsp encerrarAtendimento',rsp)          
          if (rsp.data == true) {            
            var quantAux = this.user.quantAtendimentos + 1
            this.$store
            .dispatch("QuantAtendimentos",quantAux )
            this.quantAtendimentos = quantAux
            this.fezChamada = false
		        this.atendimento.codigo = ""
		        this.atendimento.servicos = []
            this.atendimento.nomeEspecialidade = ""
            this.atendimento.prioridade = ""
		        this.numeroPaciente = ""
		        this.verificarTempoAtendimento(true)
          }

        })
        .catch(err => {
          console.log('erro. caiu no cath');
          console.log(err);
        })
	},
	
	verificarTempoAtendimento(bool){

		if(bool){
           if(this.seconds < 30 && this.quantVerificarTempoAtendimento < 2){
             this.quantVerificarTempoAtendimento++;
            setTimeout(function(){
              this.dialogAvisoAtendimento = true
            }.bind(this),6000);
	      }
		}
		if(!bool){
           if(this.seconds < 30 && this.quantVerificarTempoAtendimento < 2){
              this.quantVerificarTempoAtendimento++;
              this.dialogAvisoAtendimento = true
	      }
		}
       
	},

    setarGuiche() {
      console.log("em setar guiche...");
      this.$store
        .dispatch("Guiche", this.guicheSelecionado)
      this.guiche = this.guicheSelecionado;
    },

    retornarServicos() {      
      console.log('retornar Serviços...');      
      recepcionistaService
        .recepcionista
        .retornarServicos(this.user.idLocal)
        .then(rsp => {
          console.log('rsp de retornarServicos:',rsp)
          if(rsp.data != false){
          var rsp = rsp.data
          this.listaTabelaServicos = rsp.map(element => ({ ...element, status: false }));
          this.listaTransferirAtendimentosMedicos = this.listaTabelaServicos.filter(element => element.atendimentoMedico == 0);
          if(this.user.servicosRecepcionista){
              this.listaServicosRecepcionista = this.user.servicosRecepcionista           
          }
          else{     
            this.$store
          .dispatch("ServicosRecepcionista", this.listaTabelaServicos)
          this.listaServicosRecepcionista = this.listaTabelaServicos
          }   
          this.retornarAtendimentos()                 
          this.retornarQuantConsultas() 
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        })
    },

    retornarQuantConsultas() {
      console.log('retorn qnt consultas');
      recepcionistaService
        .recepcionista
        .retornarQuantConsultas(this.user.idLocal)
        .then(rsp => {
          console.log('rsp de retorn qnt consultas:',rsp)
          this.listaQuantConsultas = rsp.data;
          this.montarTabelaServico()
          this.desserts = this.itensTabelaConsultas;
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        })
    },

    logout() {
      console.log("em logout..");
      //this.$router.push("/login");
      this.$store
        .dispatch("FedLogOut")
        .then(rsp => {
          console.log('11111111');
          
          this.socket ? this.socket.close() : "";
          this.limparIntervalos()           
          this.$router.push("/login"); 
        })
        .catch(error => {
          //this.progress = false;
          //this.alert = true;
          //this.msg = error;
        });
    },

    groupBy(collection, property) {
      var i = 0,
        val, index,
        values = [],
        result = [];
      for (; i < collection.length; i++) {
        val = collection[i][property];
        index = values.indexOf(val);
        if (index > -1)
          result[index].push(collection[i]);
        else {
          values.push(val);
          result.push([collection[i]]);
        }
      }
      return result;
    },
  },

  mounted() {
    
    setTimeout(function () {
      this.alert = false;
    }.bind(this), 20000)
    
    console.log('imprimindo user...',this.user);    
    if (this.user.tipo != 11) {
      this.$router.push('/login')
      return
    } 

    this.retornarServicos()  
    this.socket = io.connect(socketService.SOCKET_URL, {
      query: {
        token: getToken()
      }
    });

    this.chamarSocket()
    this.guiche = !this.user.guiche ? '?' : this.user.guiche

    if(!this.user.idLocal){
       this.dialogPrimeiroAcesso = true
       return      
    }
    else{
    this.idLocalEscolhido = this.user.idLocal
    this.nomeLocal = this.user.nomeLocal 
    this.localEscolhido = this.nomeLocal 
    this.quantAtendimentos = this.user.quantAtendimentos
    this.retornarPrioridade()
    this.retornarMedicos()  
    this.tamListaAtendimentos = this.listaServicosPrioridade.length
    }

    document.body.addEventListener('keyup', (e) => {
	  	
	  if(this.user.tipo == 2 && !this.enterblock){
		if(this.dialogOrdenarExames && e.keyCode === 13){
			this.addUnidadesServicos()
		} 
		else if(this.dialogCadastrarPreferencia && e.keyCode === 13){
			if(this.step < this.listaServicosAgrupados.length -1){
                 this.step++;    
			}
			else if(this.verificaNumeroTelefone() && !this.desabilitaBotaoAdicionar){
				this.enterblock = true
				setTimeout(function(){ this.enterblock = false }.bind(this), 5000);
				this.organizarServicosEnviados()			
		    } 
		}   
		   
	  }	
    })
    
  }
};
</script>

<style scoped>
.tile {
  margin: 5px;
  border-radius: 4px;
  background: rgb(240, 133, 133);
}

.pulse {
  animation: pulse 1s infinite;
}

.pulse:hover {
  animation: 0ms;
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4);
  }

  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 44, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }

  100% {
    -moz-box-shadow: 0 0 0 0 red(0, 0, 0, 0);
    box-shadow: 0 0 0 0 red(204, 169, 44, 0);
  }
}

.rounded-card {
  border-radius: 20px;
}

.cronometro {
    font-family: 'Teko', sans-serif;
		font-size: 90px;
      }

	  .flip-list-move {
  transition: transform 0.5s;
}

  .v-overflow-btn .v-input__slot::before {
    border-color: grey !important;
  }

</style>
